export const COUNTRY_ALIASES: Record<string, string> = {
  ABW: 'ABW',
  AD: 'AND',
  AE: 'ARE',
  AF: 'AFG',
  AFG: 'AFG',
  AFGHANISTAN: 'AFG',
  AG: 'ATG',
  AGO: 'AGO',
  AI: 'AIA',
  AIA: 'AIA',
  AL: 'ALB',
  ALA: 'ALA',
  ALB: 'ALB',
  ALBANIA: 'ALB',
  ALGERIA: 'DZA',
  AM: 'ARM',
  'AMERICAN SAMOA': 'ASM',
  AMERICANSAMOA: 'ASM',
  AND: 'AND',
  ANDORRA: 'AND',
  ANGOLA: 'AGO',
  ANGUILLA: 'AIA',
  ANTARCTICA: 'ATA',
  'ANTIGUA AND BARBUDA': 'ATG',
  ANTIGUAANDBARBUDA: 'ATG',
  AO: 'AGO',
  AQ: 'ATA',
  AR: 'ARG',
  'ARAB REPUBLIC OF EGYPT': 'EGY',
  ARABREPUBLICOFEGYPT: 'EGY',
  ARE: 'ARE',
  ARG: 'ARG',
  ARGENTINA: 'ARG',
  'ARGENTINE REPUBLIC': 'ARG',
  ARGENTINEREPUBLIC: 'ARG',
  ARM: 'ARM',
  ARMENIA: 'ARM',
  ARUBA: 'ABW',
  AS: 'ASM',
  ASM: 'ASM',
  AT: 'AUT',
  ATA: 'ATA',
  ATF: 'ATF',
  ATG: 'ATG',
  AU: 'AUS',
  AUS: 'AUS',
  AUSTRALIA: 'AUS',
  AUSTRIA: 'AUT',
  AUT: 'AUT',
  AW: 'ABW',
  AX: 'ALA',
  AZ: 'AZE',
  AZE: 'AZE',
  AZERBAIJAN: 'AZE',
  BA: 'BIH',
  BAHAMAS: 'BHS',
  BAHRAIN: 'BHR',
  BANGLADESH: 'BGD',
  BARBADOS: 'BRB',
  BB: 'BRB',
  BD: 'BGD',
  BDI: 'BDI',
  BE: 'BEL',
  BEL: 'BEL',
  BELARUS: 'BLR',
  BELGIUM: 'BEL',
  BELIZE: 'BLZ',
  BEN: 'BEN',
  BENIN: 'BEN',
  BERMUDA: 'BMU',
  BES: 'BES',
  BF: 'BFA',
  BFA: 'BFA',
  BG: 'BGR',
  BGD: 'BGD',
  BGR: 'BGR',
  BH: 'BHR',
  BHR: 'BHR',
  BHS: 'BHS',
  BHUTAN: 'BTN',
  BI: 'BDI',
  BIH: 'BIH',
  BJ: 'BEN',
  BL: 'BLM',
  BLM: 'BLM',
  BLR: 'BLR',
  BLZ: 'BLZ',
  BM: 'BMU',
  BMU: 'BMU',
  BN: 'BRN',
  BO: 'BOL',
  BOL: 'BOL',
  'BOLIVARIAN REPUBLIC OF VENEZUELA': 'VEN',
  BOLIVARIANREPUBLICOFVENEZUELA: 'VEN',
  BOLIVIA: 'BOL',
  'BOLIVIA, PLURINATIONAL STATE OF': 'BOL',
  'BOLIVIA,PLURINATIONALSTATEOF': 'BOL',
  'BONAIRE, SINT EUSTATIUS AND SABA': 'BES',
  'BONAIRE,SINTEUSTATIUSANDSABA': 'BES',
  'BOSNIA AND HERZEGOVINA': 'BIH',
  BOSNIAANDHERZEGOVINA: 'BIH',
  BOTSWANA: 'BWA',
  'BOUVET ISLAND': 'BVT',
  BOUVETISLAND: 'BVT',
  BQ: 'BES',
  BR: 'BRA',
  BRA: 'BRA',
  BRAZIL: 'BRA',
  BRB: 'BRB',
  'BRITISH INDIAN OCEAN TERRITORY': 'IOT',
  'BRITISH VIRGIN ISLANDS': 'VGB',
  BRITISHINDIANOCEANTERRITORY: 'IOT',
  BRITISHVIRGINISLANDS: 'VGB',
  BRN: 'BRN',
  'BRUNEI DARUSSALAM': 'BRN',
  BRUNEIDARUSSALAM: 'BRN',
  BS: 'BHS',
  BT: 'BTN',
  BTN: 'BTN',
  BULGARIA: 'BGR',
  'BURKINA FASO': 'BFA',
  BURKINAFASO: 'BFA',
  BURUNDI: 'BDI',
  BV: 'BVT',
  BVT: 'BVT',
  BW: 'BWA',
  BWA: 'BWA',
  BY: 'BLR',
  BZ: 'BLZ',
  CA: 'CAN',
  'CABO VERDE': 'CPV',
  CABOVERDE: 'CPV',
  CAF: 'CAF',
  CAMBODIA: 'KHM',
  CAMEROON: 'CMR',
  CAN: 'CAN',
  CANADA: 'CAN',
  'CAYMAN ISLANDS': 'CYM',
  CAYMANISLANDS: 'CYM',
  CC: 'CCK',
  CCK: 'CCK',
  CD: 'COD',
  'CENTRAL AFRICAN REPUBLIC': 'CAF',
  CENTRALAFRICANREPUBLIC: 'CAF',
  CF: 'CAF',
  CG: 'COG',
  CH: 'CHE',
  CHAD: 'TCD',
  CHE: 'CHE',
  CHILE: 'CHL',
  CHINA: 'CHN',
  CHL: 'CHL',
  CHN: 'CHN',
  'CHRISTMAS ISLAND': 'CXR',
  CHRISTMASISLAND: 'CXR',
  CI: 'CIV',
  CIV: 'CIV',
  CK: 'COK',
  CL: 'CHL',
  CM: 'CMR',
  CMR: 'CMR',
  CN: 'CHN',
  CO: 'COL',
  'COCOS (KEELING) ISLANDS': 'CCK',
  'COCOS(KEELING)ISLANDS': 'CCK',
  COD: 'COD',
  COG: 'COG',
  COK: 'COK',
  COL: 'COL',
  COLOMBIA: 'COL',
  COM: 'COM',
  'COMMONWEALTH OF DOMINICA': 'DMA',
  'COMMONWEALTH OF THE BAHAMAS': 'BHS',
  'COMMONWEALTH OF THE NORTHERN MARIANA ISLANDS': 'MNP',
  COMMONWEALTHOFDOMINICA: 'DMA',
  COMMONWEALTHOFTHEBAHAMAS: 'BHS',
  COMMONWEALTHOFTHENORTHERNMARIANAISLANDS: 'MNP',
  COMOROS: 'COM',
  CONGO: 'COG',
  'CONGO, THE DEMOCRATIC REPUBLIC OF THE': 'COD',
  'CONGO,THEDEMOCRATICREPUBLICOFTHE': 'COD',
  'COOK ISLANDS': 'COK',
  COOKISLANDS: 'COK',
  'COSTA RICA': 'CRI',
  COSTARICA: 'CRI',
  CPV: 'CPV',
  CR: 'CRI',
  CRI: 'CRI',
  CROATIA: 'HRV',
  CU: 'CUB',
  CUB: 'CUB',
  CUBA: 'CUB',
  'CURAÇAO': 'CUW',
  CUW: 'CUW',
  CV: 'CPV',
  CW: 'CUW',
  CX: 'CXR',
  CXR: 'CXR',
  CY: 'CYP',
  CYM: 'CYM',
  CYP: 'CYP',
  CYPRUS: 'CYP',
  CZ: 'CZE',
  CZE: 'CZE',
  'CZECH REPUBLIC': 'CZE',
  CZECHIA: 'CZE',
  CZECHREPUBLIC: 'CZE',
  "CÔTE D'IVOIRE": 'CIV',
  "CÔTED'IVOIRE": 'CIV',
  DE: 'DEU',
  "DEMOCRATIC PEOPLE'S REPUBLIC OF KOREA": 'PRK',
  'DEMOCRATIC REPUBLIC OF SAO TOME AND PRINCIPE': 'STP',
  'DEMOCRATIC REPUBLIC OF TIMOR-LESTE': 'TLS',
  'DEMOCRATIC SOCIALIST REPUBLIC OF SRI LANKA': 'LKA',
  "DEMOCRATICPEOPLE'SREPUBLICOFKOREA": 'PRK',
  DEMOCRATICREPUBLICOFSAOTOMEANDPRINCIPE: 'STP',
  'DEMOCRATICREPUBLICOFTIMOR-LESTE': 'TLS',
  DEMOCRATICSOCIALISTREPUBLICOFSRILANKA: 'LKA',
  DENMARK: 'DNK',
  DEU: 'DEU',
  DJ: 'DJI',
  DJI: 'DJI',
  DJIBOUTI: 'DJI',
  DK: 'DNK',
  DM: 'DMA',
  DMA: 'DMA',
  DNK: 'DNK',
  DO: 'DOM',
  DOM: 'DOM',
  DOMINICA: 'DMA',
  'DOMINICAN REPUBLIC': 'DOM',
  DOMINICANREPUBLIC: 'DOM',
  DPRK: 'PRK',
  DZ: 'DZA',
  DZA: 'DZA',
  'EASTERN REPUBLIC OF URUGUAY': 'URY',
  EASTERNREPUBLICOFURUGUAY: 'URY',
  EC: 'ECU',
  ECU: 'ECU',
  ECUADOR: 'ECU',
  EE: 'EST',
  EG: 'EGY',
  EGY: 'EGY',
  EGYPT: 'EGY',
  EH: 'ESH',
  'EL SALVADOR': 'SLV',
  ELSALVADOR: 'SLV',
  'EQUATORIAL GUINEA': 'GNQ',
  EQUATORIALGUINEA: 'GNQ',
  ER: 'ERI',
  ERI: 'ERI',
  ERITREA: 'ERI',
  ES: 'ESP',
  ESH: 'ESH',
  ESP: 'ESP',
  EST: 'EST',
  ESTONIA: 'EST',
  ESWATINI: 'SWZ',
  ET: 'ETH',
  ETH: 'ETH',
  ETHIOPIA: 'ETH',
  'FALKLAND ISLANDS (MALVINAS)': 'FLK',
  'FALKLANDISLANDS(MALVINAS)': 'FLK',
  'FAROE ISLANDS': 'FRO',
  FAROEISLANDS: 'FRO',
  'FEDERAL DEMOCRATIC REPUBLIC OF ETHIOPIA': 'ETH',
  'FEDERAL DEMOCRATIC REPUBLIC OF NEPAL': 'NPL',
  'FEDERAL REPUBLIC OF GERMANY': 'DEU',
  'FEDERAL REPUBLIC OF NIGERIA': 'NGA',
  'FEDERAL REPUBLIC OF SOMALIA': 'SOM',
  FEDERALDEMOCRATICREPUBLICOFETHIOPIA: 'ETH',
  FEDERALDEMOCRATICREPUBLICOFNEPAL: 'NPL',
  FEDERALREPUBLICOFGERMANY: 'DEU',
  FEDERALREPUBLICOFNIGERIA: 'NGA',
  FEDERALREPUBLICOFSOMALIA: 'SOM',
  'FEDERATED STATES OF MICRONESIA': 'FSM',
  FEDERATEDSTATESOFMICRONESIA: 'FSM',
  'FEDERATIVE REPUBLIC OF BRAZIL': 'BRA',
  FEDERATIVEREPUBLICOFBRAZIL: 'BRA',
  FI: 'FIN',
  FIJI: 'FJI',
  FIN: 'FIN',
  FINLAND: 'FIN',
  FJ: 'FJI',
  FJI: 'FJI',
  FK: 'FLK',
  FLK: 'FLK',
  FM: 'FSM',
  FO: 'FRO',
  FR: 'FRA',
  FRA: 'FRA',
  FRANCE: 'FRA',
  'FRENCH GUIANA': 'GUF',
  'FRENCH POLYNESIA': 'PYF',
  'FRENCH REPUBLIC': 'FRA',
  'FRENCH SOUTHERN TERRITORIES': 'ATF',
  FRENCHGUIANA: 'GUF',
  FRENCHPOLYNESIA: 'PYF',
  FRENCHREPUBLIC: 'FRA',
  FRENCHSOUTHERNTERRITORIES: 'ATF',
  FRO: 'FRO',
  FSM: 'FSM',
  GA: 'GAB',
  GAB: 'GAB',
  GABON: 'GAB',
  'GABONESE REPUBLIC': 'GAB',
  GABONESEREPUBLIC: 'GAB',
  GAMBIA: 'GMB',
  GB: 'GBR',
  GBR: 'GBR',
  GD: 'GRD',
  GE: 'GEO',
  GEO: 'GEO',
  GEORGIA: 'GEO',
  GERMANY: 'DEU',
  GF: 'GUF',
  GG: 'GGY',
  GGY: 'GGY',
  GH: 'GHA',
  GHA: 'GHA',
  GHANA: 'GHA',
  GI: 'GIB',
  GIB: 'GIB',
  GIBRALTAR: 'GIB',
  GIN: 'GIN',
  GL: 'GRL',
  GLP: 'GLP',
  GM: 'GMB',
  GMB: 'GMB',
  GN: 'GIN',
  GNB: 'GNB',
  GNQ: 'GNQ',
  GP: 'GLP',
  GQ: 'GNQ',
  GR: 'GRC',
  'GRAND DUCHY OF LUXEMBOURG': 'LUX',
  GRANDDUCHYOFLUXEMBOURG: 'LUX',
  GRC: 'GRC',
  GRD: 'GRD',
  GREECE: 'GRC',
  GREENLAND: 'GRL',
  GRENADA: 'GRD',
  GRL: 'GRL',
  GS: 'SGS',
  GT: 'GTM',
  GTM: 'GTM',
  GU: 'GUM',
  GUADELOUPE: 'GLP',
  GUAM: 'GUM',
  GUATEMALA: 'GTM',
  GUERNSEY: 'GGY',
  GUF: 'GUF',
  GUINEA: 'GIN',
  'GUINEA-BISSAU': 'GNB',
  GUM: 'GUM',
  GUY: 'GUY',
  GUYANA: 'GUY',
  GW: 'GNB',
  GY: 'GUY',
  HAITI: 'HTI',
  'HASHEMITE KINGDOM OF JORDAN': 'JOR',
  HASHEMITEKINGDOMOFJORDAN: 'JOR',
  'HEARD ISLAND AND MCDONALD ISLANDS': 'HMD',
  HEARDISLANDANDMCDONALDISLANDS: 'HMD',
  'HELLENIC REPUBLIC': 'GRC',
  HELLENICREPUBLIC: 'GRC',
  HK: 'HKG',
  HKG: 'HKG',
  HM: 'HMD',
  HMD: 'HMD',
  HN: 'HND',
  HND: 'HND',
  'HOLY SEE (VATICAN CITY STATE)': 'VAT',
  'HOLYSEE(VATICANCITYSTATE)': 'VAT',
  HONDURAS: 'HND',
  'HONG KONG': 'HKG',
  'HONG KONG SPECIAL ADMINISTRATIVE REGION OF CHINA': 'HKG',
  HONGKONG: 'HKG',
  HONGKONGSPECIALADMINISTRATIVEREGIONOFCHINA: 'HKG',
  HR: 'HRV',
  HRV: 'HRV',
  HT: 'HTI',
  HTI: 'HTI',
  HU: 'HUN',
  HUN: 'HUN',
  HUNGARY: 'HUN',
  ICELAND: 'ISL',
  ID: 'IDN',
  IDN: 'IDN',
  IE: 'IRL',
  IL: 'ISR',
  IM: 'IMN',
  IMN: 'IMN',
  IN: 'IND',
  IND: 'IND',
  'INDEPENDENT STATE OF PAPUA NEW GUINEA': 'PNG',
  'INDEPENDENT STATE OF SAMOA': 'WSM',
  INDEPENDENTSTATEOFPAPUANEWGUINEA: 'PNG',
  INDEPENDENTSTATEOFSAMOA: 'WSM',
  INDIA: 'IND',
  INDONESIA: 'IDN',
  IO: 'IOT',
  IOT: 'IOT',
  IQ: 'IRQ',
  IR: 'IRN',
  IRAN: 'IRN',
  'IRAN, ISLAMIC REPUBLIC OF': 'IRN',
  'IRAN,ISLAMICREPUBLICOF': 'IRN',
  IRAQ: 'IRQ',
  IRELAND: 'IRL',
  IRL: 'IRL',
  IRN: 'IRN',
  IRQ: 'IRQ',
  IS: 'ISL',
  ISL: 'ISL',
  'ISLAMIC REPUBLIC OF AFGHANISTAN': 'AFG',
  'ISLAMIC REPUBLIC OF IRAN': 'IRN',
  'ISLAMIC REPUBLIC OF MAURITANIA': 'MRT',
  'ISLAMIC REPUBLIC OF PAKISTAN': 'PAK',
  ISLAMICREPUBLICOFAFGHANISTAN: 'AFG',
  ISLAMICREPUBLICOFIRAN: 'IRN',
  ISLAMICREPUBLICOFMAURITANIA: 'MRT',
  ISLAMICREPUBLICOFPAKISTAN: 'PAK',
  'ISLE OF MAN': 'IMN',
  ISLEOFMAN: 'IMN',
  ISR: 'ISR',
  ISRAEL: 'ISR',
  IT: 'ITA',
  ITA: 'ITA',
  'ITALIAN REPUBLIC': 'ITA',
  ITALIANREPUBLIC: 'ITA',
  ITALY: 'ITA',
  JAM: 'JAM',
  JAMAICA: 'JAM',
  JAPAN: 'JPN',
  JE: 'JEY',
  JERSEY: 'JEY',
  JEY: 'JEY',
  JM: 'JAM',
  JO: 'JOR',
  JOR: 'JOR',
  JORDAN: 'JOR',
  JP: 'JPN',
  JPN: 'JPN',
  KAZ: 'KAZ',
  KAZAKHSTAN: 'KAZ',
  KE: 'KEN',
  KEN: 'KEN',
  KENYA: 'KEN',
  KG: 'KGZ',
  KGZ: 'KGZ',
  KH: 'KHM',
  KHM: 'KHM',
  KI: 'KIR',
  'KINGDOM OF BAHRAIN': 'BHR',
  'KINGDOM OF BELGIUM': 'BEL',
  'KINGDOM OF BHUTAN': 'BTN',
  'KINGDOM OF CAMBODIA': 'KHM',
  'KINGDOM OF DENMARK': 'DNK',
  'KINGDOM OF ESWATINI': 'SWZ',
  'KINGDOM OF LESOTHO': 'LSO',
  'KINGDOM OF MOROCCO': 'MAR',
  'KINGDOM OF NORWAY': 'NOR',
  'KINGDOM OF SAUDI ARABIA': 'SAU',
  'KINGDOM OF SPAIN': 'ESP',
  'KINGDOM OF SWEDEN': 'SWE',
  'KINGDOM OF THAILAND': 'THA',
  'KINGDOM OF THE NETHERLANDS': 'NLD',
  'KINGDOM OF TONGA': 'TON',
  KINGDOMOFBAHRAIN: 'BHR',
  KINGDOMOFBELGIUM: 'BEL',
  KINGDOMOFBHUTAN: 'BTN',
  KINGDOMOFCAMBODIA: 'KHM',
  KINGDOMOFDENMARK: 'DNK',
  KINGDOMOFESWATINI: 'SWZ',
  KINGDOMOFLESOTHO: 'LSO',
  KINGDOMOFMOROCCO: 'MAR',
  KINGDOMOFNORWAY: 'NOR',
  KINGDOMOFSAUDIARABIA: 'SAU',
  KINGDOMOFSPAIN: 'ESP',
  KINGDOMOFSWEDEN: 'SWE',
  KINGDOMOFTHAILAND: 'THA',
  KINGDOMOFTHENETHERLANDS: 'NLD',
  KINGDOMOFTONGA: 'TON',
  KIR: 'KIR',
  KIRIBATI: 'KIR',
  KM: 'COM',
  KN: 'KNA',
  KNA: 'KNA',
  KOR: 'KOR',
  'KOREA SOUTH': 'KOR',
  "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": 'PRK',
  'KOREA, REPUBLIC OF': 'KOR',
  "KOREA,DEMOCRATICPEOPLE'SREPUBLICOF": 'PRK',
  'KOREA,REPUBLICOF': 'KOR',
  KP: 'PRK',
  KR: 'KOR',
  KUWAIT: 'KWT',
  KW: 'KWT',
  KWT: 'KWT',
  KY: 'CYM',
  'KYRGYZ REPUBLIC': 'KGZ',
  KYRGYZREPUBLIC: 'KGZ',
  KYRGYZSTAN: 'KGZ',
  KZ: 'KAZ',
  LA: 'LAO',
  LAO: 'LAO',
  "LAO PEOPLE'S DEMOCRATIC REPUBLIC": 'LAO',
  "LAOPEOPLE'SDEMOCRATICREPUBLIC": 'LAO',
  LAOS: 'LAO',
  LATVIA: 'LVA',
  LB: 'LBN',
  LBN: 'LBN',
  LBR: 'LBR',
  LBY: 'LBY',
  LC: 'LCA',
  LCA: 'LCA',
  'LEBANESE REPUBLIC': 'LBN',
  LEBANESEREPUBLIC: 'LBN',
  LEBANON: 'LBN',
  LESOTHO: 'LSO',
  LI: 'LIE',
  LIBERIA: 'LBR',
  LIBYA: 'LBY',
  LIE: 'LIE',
  LIECHTENSTEIN: 'LIE',
  LITHUANIA: 'LTU',
  LK: 'LKA',
  LKA: 'LKA',
  LR: 'LBR',
  LS: 'LSO',
  LSO: 'LSO',
  LT: 'LTU',
  LTU: 'LTU',
  LU: 'LUX',
  LUX: 'LUX',
  LUXEMBOURG: 'LUX',
  LV: 'LVA',
  LVA: 'LVA',
  LY: 'LBY',
  MA: 'MAR',
  MAC: 'MAC',
  MACAO: 'MAC',
  'MACAO SPECIAL ADMINISTRATIVE REGION OF CHINA': 'MAC',
  MACAOSPECIALADMINISTRATIVEREGIONOFCHINA: 'MAC',
  MADAGASCAR: 'MDG',
  MAF: 'MAF',
  MALAWI: 'MWI',
  MALAYSIA: 'MYS',
  MALDIVES: 'MDV',
  MALI: 'MLI',
  MALTA: 'MLT',
  MAR: 'MAR',
  'MARSHALL ISLANDS': 'MHL',
  MARSHALLISLANDS: 'MHL',
  MARTINIQUE: 'MTQ',
  MAURITANIA: 'MRT',
  MAURITIUS: 'MUS',
  MAYOTTE: 'MYT',
  MC: 'MCO',
  MCO: 'MCO',
  MD: 'MDA',
  MDA: 'MDA',
  MDG: 'MDG',
  MDV: 'MDV',
  ME: 'MNE',
  MEX: 'MEX',
  MEXICO: 'MEX',
  MF: 'MAF',
  MG: 'MDG',
  MH: 'MHL',
  MHL: 'MHL',
  'MICRONESIA, FEDERATED STATES OF': 'FSM',
  'MICRONESIA,FEDERATEDSTATESOF': 'FSM',
  MK: 'MKD',
  MKD: 'MKD',
  ML: 'MLI',
  MLI: 'MLI',
  MLT: 'MLT',
  MM: 'MMR',
  MMR: 'MMR',
  MN: 'MNG',
  MNE: 'MNE',
  MNG: 'MNG',
  MNP: 'MNP',
  MO: 'MAC',
  MOLDOVA: 'MDA',
  'MOLDOVA, REPUBLIC OF': 'MDA',
  'MOLDOVA,REPUBLICOF': 'MDA',
  MONACO: 'MCO',
  MONGOLIA: 'MNG',
  MONTENEGRO: 'MNE',
  MONTSERRAT: 'MSR',
  MOROCCO: 'MAR',
  MOZ: 'MOZ',
  MOZAMBIQUE: 'MOZ',
  MP: 'MNP',
  MQ: 'MTQ',
  MR: 'MRT',
  MRT: 'MRT',
  MS: 'MSR',
  MSR: 'MSR',
  MT: 'MLT',
  MTQ: 'MTQ',
  MU: 'MUS',
  MUS: 'MUS',
  MV: 'MDV',
  MW: 'MWI',
  MWI: 'MWI',
  MX: 'MEX',
  MY: 'MYS',
  MYANMAR: 'MMR',
  MYS: 'MYS',
  MYT: 'MYT',
  MZ: 'MOZ',
  NA: 'NAM',
  NAM: 'NAM',
  NAMIBIA: 'NAM',
  NAURU: 'NRU',
  NC: 'NCL',
  NCL: 'NCL',
  NE: 'NER',
  NEPAL: 'NPL',
  NER: 'NER',
  NETHERLANDS: 'NLD',
  'NEW CALEDONIA': 'NCL',
  'NEW ZEALAND': 'NZL',
  NEWCALEDONIA: 'NCL',
  NEWZEALAND: 'NZL',
  NF: 'NFK',
  NFK: 'NFK',
  NG: 'NGA',
  NGA: 'NGA',
  NI: 'NIC',
  NIC: 'NIC',
  NICARAGUA: 'NIC',
  NIGER: 'NER',
  NIGERIA: 'NGA',
  NIU: 'NIU',
  NIUE: 'NIU',
  NL: 'NLD',
  NLD: 'NLD',
  NO: 'NOR',
  NOR: 'NOR',
  'NORFOLK ISLAND': 'NFK',
  NORFOLKISLAND: 'NFK',
  'NORTH KOREA': 'PRK',
  'NORTH MACEDONIA': 'MKD',
  'NORTHERN MARIANA ISLANDS': 'MNP',
  NORTHERNMARIANAISLANDS: 'MNP',
  NORTHKOREA: 'PRK',
  NORTHMACEDONIA: 'MKD',
  NORWAY: 'NOR',
  NP: 'NPL',
  NPL: 'NPL',
  NR: 'NRU',
  NRU: 'NRU',
  NU: 'NIU',
  NZ: 'NZL',
  NZL: 'NZL',
  OM: 'OMN',
  OMAN: 'OMN',
  OMN: 'OMN',
  PA: 'PAN',
  PAK: 'PAK',
  PAKISTAN: 'PAK',
  PALAU: 'PLW',
  'PALESTINE, STATE OF': 'PSE',
  'PALESTINE,STATEOF': 'PSE',
  PAN: 'PAN',
  PANAMA: 'PAN',
  'PAPUA NEW GUINEA': 'PNG',
  PAPUANEWGUINEA: 'PNG',
  PARAGUAY: 'PRY',
  PCN: 'PCN',
  PE: 'PER',
  "PEOPLE'S DEMOCRATIC REPUBLIC OF ALGERIA": 'DZA',
  "PEOPLE'S REPUBLIC OF BANGLADESH": 'BGD',
  "PEOPLE'S REPUBLIC OF CHINA": 'CHN',
  "PEOPLE'SDEMOCRATICREPUBLICOFALGERIA": 'DZA',
  "PEOPLE'SREPUBLICOFBANGLADESH": 'BGD',
  "PEOPLE'SREPUBLICOFCHINA": 'CHN',
  PER: 'PER',
  PERU: 'PER',
  PF: 'PYF',
  PG: 'PNG',
  PH: 'PHL',
  PHILIPPINES: 'PHL',
  PHL: 'PHL',
  PITCAIRN: 'PCN',
  PK: 'PAK',
  PL: 'POL',
  'PLURINATIONAL STATE OF BOLIVIA': 'BOL',
  PLURINATIONALSTATEOFBOLIVIA: 'BOL',
  PLW: 'PLW',
  PM: 'SPM',
  PN: 'PCN',
  PNG: 'PNG',
  POL: 'POL',
  POLAND: 'POL',
  PORTUGAL: 'PRT',
  'PORTUGUESE REPUBLIC': 'PRT',
  PORTUGUESEREPUBLIC: 'PRT',
  PR: 'PRI',
  PRI: 'PRI',
  'PRINCIPALITY OF ANDORRA': 'AND',
  'PRINCIPALITY OF LIECHTENSTEIN': 'LIE',
  'PRINCIPALITY OF MONACO': 'MCO',
  PRINCIPALITYOFANDORRA: 'AND',
  PRINCIPALITYOFLIECHTENSTEIN: 'LIE',
  PRINCIPALITYOFMONACO: 'MCO',
  PRK: 'PRK',
  PRT: 'PRT',
  PRY: 'PRY',
  PS: 'PSE',
  PSE: 'PSE',
  PT: 'PRT',
  'PUERTO RICO': 'PRI',
  PUERTORICO: 'PRI',
  PW: 'PLW',
  PY: 'PRY',
  PYF: 'PYF',
  QA: 'QAT',
  QAT: 'QAT',
  QATAR: 'QAT',
  RE: 'REU',
  'REPUBLIC OF ALBANIA': 'ALB',
  'REPUBLIC OF ANGOLA': 'AGO',
  'REPUBLIC OF ARMENIA': 'ARM',
  'REPUBLIC OF AUSTRIA': 'AUT',
  'REPUBLIC OF AZERBAIJAN': 'AZE',
  'REPUBLIC OF BELARUS': 'BLR',
  'REPUBLIC OF BENIN': 'BEN',
  'REPUBLIC OF BOSNIA AND HERZEGOVINA': 'BIH',
  'REPUBLIC OF BOTSWANA': 'BWA',
  'REPUBLIC OF BULGARIA': 'BGR',
  'REPUBLIC OF BURUNDI': 'BDI',
  'REPUBLIC OF CABO VERDE': 'CPV',
  'REPUBLIC OF CAMEROON': 'CMR',
  'REPUBLIC OF CHAD': 'TCD',
  'REPUBLIC OF CHILE': 'CHL',
  'REPUBLIC OF COLOMBIA': 'COL',
  'REPUBLIC OF COSTA RICA': 'CRI',
  'REPUBLIC OF CROATIA': 'HRV',
  'REPUBLIC OF CUBA': 'CUB',
  'REPUBLIC OF CYPRUS': 'CYP',
  "REPUBLIC OF CÔTE D'IVOIRE": 'CIV',
  'REPUBLIC OF DJIBOUTI': 'DJI',
  'REPUBLIC OF ECUADOR': 'ECU',
  'REPUBLIC OF EL SALVADOR': 'SLV',
  'REPUBLIC OF EQUATORIAL GUINEA': 'GNQ',
  'REPUBLIC OF ESTONIA': 'EST',
  'REPUBLIC OF FIJI': 'FJI',
  'REPUBLIC OF FINLAND': 'FIN',
  'REPUBLIC OF GHANA': 'GHA',
  'REPUBLIC OF GUATEMALA': 'GTM',
  'REPUBLIC OF GUINEA': 'GIN',
  'REPUBLIC OF GUINEA-BISSAU': 'GNB',
  'REPUBLIC OF GUYANA': 'GUY',
  'REPUBLIC OF HAITI': 'HTI',
  'REPUBLIC OF HONDURAS': 'HND',
  'REPUBLIC OF ICELAND': 'ISL',
  'REPUBLIC OF INDIA': 'IND',
  'REPUBLIC OF INDONESIA': 'IDN',
  'REPUBLIC OF IRAQ': 'IRQ',
  'REPUBLIC OF KAZAKHSTAN': 'KAZ',
  'REPUBLIC OF KENYA': 'KEN',
  'REPUBLIC OF KIRIBATI': 'KIR',
  'REPUBLIC OF LATVIA': 'LVA',
  'REPUBLIC OF LIBERIA': 'LBR',
  'REPUBLIC OF LITHUANIA': 'LTU',
  'REPUBLIC OF MADAGASCAR': 'MDG',
  'REPUBLIC OF MALAWI': 'MWI',
  'REPUBLIC OF MALDIVES': 'MDV',
  'REPUBLIC OF MALI': 'MLI',
  'REPUBLIC OF MALTA': 'MLT',
  'REPUBLIC OF MAURITIUS': 'MUS',
  'REPUBLIC OF MOLDOVA': 'MDA',
  'REPUBLIC OF MOZAMBIQUE': 'MOZ',
  'REPUBLIC OF MYANMAR': 'MMR',
  'REPUBLIC OF NAMIBIA': 'NAM',
  'REPUBLIC OF NAURU': 'NRU',
  'REPUBLIC OF NICARAGUA': 'NIC',
  'REPUBLIC OF NORTH MACEDONIA': 'MKD',
  'REPUBLIC OF PALAU': 'PLW',
  'REPUBLIC OF PANAMA': 'PAN',
  'REPUBLIC OF PARAGUAY': 'PRY',
  'REPUBLIC OF PERU': 'PER',
  'REPUBLIC OF POLAND': 'POL',
  'REPUBLIC OF SAN MARINO': 'SMR',
  'REPUBLIC OF SENEGAL': 'SEN',
  'REPUBLIC OF SERBIA': 'SRB',
  'REPUBLIC OF SEYCHELLES': 'SYC',
  'REPUBLIC OF SIERRA LEONE': 'SLE',
  'REPUBLIC OF SINGAPORE': 'SGP',
  'REPUBLIC OF SLOVENIA': 'SVN',
  'REPUBLIC OF SOUTH AFRICA': 'ZAF',
  'REPUBLIC OF SOUTH SUDAN': 'SSD',
  'REPUBLIC OF SURINAME': 'SUR',
  'REPUBLIC OF TAJIKISTAN': 'TJK',
  'REPUBLIC OF THE CONGO': 'COG',
  'REPUBLIC OF THE GAMBIA': 'GMB',
  'REPUBLIC OF THE MARSHALL ISLANDS': 'MHL',
  'REPUBLIC OF THE NIGER': 'NER',
  'REPUBLIC OF THE PHILIPPINES': 'PHL',
  'REPUBLIC OF THE SUDAN': 'SDN',
  'REPUBLIC OF TRINIDAD AND TOBAGO': 'TTO',
  'REPUBLIC OF TUNISIA': 'TUN',
  'REPUBLIC OF TÜRKIYE': 'TUR',
  'REPUBLIC OF UGANDA': 'UGA',
  'REPUBLIC OF UZBEKISTAN': 'UZB',
  'REPUBLIC OF VANUATU': 'VUT',
  'REPUBLIC OF YEMEN': 'YEM',
  'REPUBLIC OF ZAMBIA': 'ZMB',
  'REPUBLIC OF ZIMBABWE': 'ZWE',
  REPUBLICOFALBANIA: 'ALB',
  REPUBLICOFANGOLA: 'AGO',
  REPUBLICOFARMENIA: 'ARM',
  REPUBLICOFAUSTRIA: 'AUT',
  REPUBLICOFAZERBAIJAN: 'AZE',
  REPUBLICOFBELARUS: 'BLR',
  REPUBLICOFBENIN: 'BEN',
  REPUBLICOFBOSNIAANDHERZEGOVINA: 'BIH',
  REPUBLICOFBOTSWANA: 'BWA',
  REPUBLICOFBULGARIA: 'BGR',
  REPUBLICOFBURUNDI: 'BDI',
  REPUBLICOFCABOVERDE: 'CPV',
  REPUBLICOFCAMEROON: 'CMR',
  REPUBLICOFCHAD: 'TCD',
  REPUBLICOFCHILE: 'CHL',
  REPUBLICOFCOLOMBIA: 'COL',
  REPUBLICOFCOSTARICA: 'CRI',
  REPUBLICOFCROATIA: 'HRV',
  REPUBLICOFCUBA: 'CUB',
  REPUBLICOFCYPRUS: 'CYP',
  "REPUBLICOFCÔTED'IVOIRE": 'CIV',
  REPUBLICOFDJIBOUTI: 'DJI',
  REPUBLICOFECUADOR: 'ECU',
  REPUBLICOFELSALVADOR: 'SLV',
  REPUBLICOFEQUATORIALGUINEA: 'GNQ',
  REPUBLICOFESTONIA: 'EST',
  REPUBLICOFFIJI: 'FJI',
  REPUBLICOFFINLAND: 'FIN',
  REPUBLICOFGHANA: 'GHA',
  REPUBLICOFGUATEMALA: 'GTM',
  REPUBLICOFGUINEA: 'GIN',
  'REPUBLICOFGUINEA-BISSAU': 'GNB',
  REPUBLICOFGUYANA: 'GUY',
  REPUBLICOFHAITI: 'HTI',
  REPUBLICOFHONDURAS: 'HND',
  REPUBLICOFICELAND: 'ISL',
  REPUBLICOFINDIA: 'IND',
  REPUBLICOFINDONESIA: 'IDN',
  REPUBLICOFIRAQ: 'IRQ',
  REPUBLICOFKAZAKHSTAN: 'KAZ',
  REPUBLICOFKENYA: 'KEN',
  REPUBLICOFKIRIBATI: 'KIR',
  REPUBLICOFLATVIA: 'LVA',
  REPUBLICOFLIBERIA: 'LBR',
  REPUBLICOFLITHUANIA: 'LTU',
  REPUBLICOFMADAGASCAR: 'MDG',
  REPUBLICOFMALAWI: 'MWI',
  REPUBLICOFMALDIVES: 'MDV',
  REPUBLICOFMALI: 'MLI',
  REPUBLICOFMALTA: 'MLT',
  REPUBLICOFMAURITIUS: 'MUS',
  REPUBLICOFMOLDOVA: 'MDA',
  REPUBLICOFMOZAMBIQUE: 'MOZ',
  REPUBLICOFMYANMAR: 'MMR',
  REPUBLICOFNAMIBIA: 'NAM',
  REPUBLICOFNAURU: 'NRU',
  REPUBLICOFNICARAGUA: 'NIC',
  REPUBLICOFNORTHMACEDONIA: 'MKD',
  REPUBLICOFPALAU: 'PLW',
  REPUBLICOFPANAMA: 'PAN',
  REPUBLICOFPARAGUAY: 'PRY',
  REPUBLICOFPERU: 'PER',
  REPUBLICOFPOLAND: 'POL',
  REPUBLICOFSANMARINO: 'SMR',
  REPUBLICOFSENEGAL: 'SEN',
  REPUBLICOFSERBIA: 'SRB',
  REPUBLICOFSEYCHELLES: 'SYC',
  REPUBLICOFSIERRALEONE: 'SLE',
  REPUBLICOFSINGAPORE: 'SGP',
  REPUBLICOFSLOVENIA: 'SVN',
  REPUBLICOFSOUTHAFRICA: 'ZAF',
  REPUBLICOFSOUTHSUDAN: 'SSD',
  REPUBLICOFSURINAME: 'SUR',
  REPUBLICOFTAJIKISTAN: 'TJK',
  REPUBLICOFTHECONGO: 'COG',
  REPUBLICOFTHEGAMBIA: 'GMB',
  REPUBLICOFTHEMARSHALLISLANDS: 'MHL',
  REPUBLICOFTHENIGER: 'NER',
  REPUBLICOFTHEPHILIPPINES: 'PHL',
  REPUBLICOFTHESUDAN: 'SDN',
  REPUBLICOFTRINIDADANDTOBAGO: 'TTO',
  REPUBLICOFTUNISIA: 'TUN',
  'REPUBLICOFTÜRKIYE': 'TUR',
  REPUBLICOFUGANDA: 'UGA',
  REPUBLICOFUZBEKISTAN: 'UZB',
  REPUBLICOFVANUATU: 'VUT',
  REPUBLICOFYEMEN: 'YEM',
  REPUBLICOFZAMBIA: 'ZMB',
  REPUBLICOFZIMBABWE: 'ZWE',
  REU: 'REU',
  RO: 'ROU',
  ROMANIA: 'ROU',
  ROU: 'ROU',
  RS: 'SRB',
  RU: 'RUS',
  RUS: 'RUS',
  RUSSIA: 'RUS',
  'RUSSIAN FEDERATION': 'RUS',
  RUSSIANFEDERATION: 'RUS',
  RW: 'RWA',
  RWA: 'RWA',
  RWANDA: 'RWA',
  'RWANDESE REPUBLIC': 'RWA',
  RWANDESEREPUBLIC: 'RWA',
  'RÉUNION': 'REU',
  SA: 'SAU',
  'SAINT BARTHÉLEMY': 'BLM',
  'SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA': 'SHN',
  'SAINT KITTS AND NEVIS': 'KNA',
  'SAINT LUCIA': 'LCA',
  'SAINT MARTIN (FRENCH PART)': 'MAF',
  'SAINT PIERRE AND MIQUELON': 'SPM',
  'SAINT VINCENT AND THE GRENADINES': 'VCT',
  'SAINTBARTHÉLEMY': 'BLM',
  'SAINTHELENA,ASCENSIONANDTRISTANDACUNHA': 'SHN',
  SAINTKITTSANDNEVIS: 'KNA',
  SAINTLUCIA: 'LCA',
  'SAINTMARTIN(FRENCHPART)': 'MAF',
  SAINTPIERREANDMIQUELON: 'SPM',
  SAINTVINCENTANDTHEGRENADINES: 'VCT',
  SAMOA: 'WSM',
  'SAN MARINO': 'SMR',
  SANMARINO: 'SMR',
  'SAO TOME AND PRINCIPE': 'STP',
  SAOTOMEANDPRINCIPE: 'STP',
  SAU: 'SAU',
  'SAUDI ARABIA': 'SAU',
  SAUDIARABIA: 'SAU',
  SB: 'SLB',
  SC: 'SYC',
  SD: 'SDN',
  SDN: 'SDN',
  SE: 'SWE',
  SEN: 'SEN',
  SENEGAL: 'SEN',
  SERBIA: 'SRB',
  SEYCHELLES: 'SYC',
  SG: 'SGP',
  SGP: 'SGP',
  SGS: 'SGS',
  SH: 'SHN',
  SHN: 'SHN',
  SI: 'SVN',
  'SIERRA LEONE': 'SLE',
  SIERRALEONE: 'SLE',
  SINGAPORE: 'SGP',
  'SINT MAARTEN (DUTCH PART)': 'SXM',
  'SINTMAARTEN(DUTCHPART)': 'SXM',
  SJ: 'SJM',
  SJM: 'SJM',
  SK: 'SVK',
  SL: 'SLE',
  SLB: 'SLB',
  SLE: 'SLE',
  'SLOVAK REPUBLIC': 'SVK',
  SLOVAKIA: 'SVK',
  SLOVAKREPUBLIC: 'SVK',
  SLOVENIA: 'SVN',
  SLV: 'SLV',
  SM: 'SMR',
  SMR: 'SMR',
  SN: 'SEN',
  SO: 'SOM',
  'SOCIALIST REPUBLIC OF VIET NAM': 'VNM',
  SOCIALISTREPUBLICOFVIETNAM: 'VNM',
  'SOLOMON ISLANDS': 'SLB',
  SOLOMONISLANDS: 'SLB',
  SOM: 'SOM',
  SOMALIA: 'SOM',
  'SOUTH AFRICA': 'ZAF',
  'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS': 'SGS',
  'SOUTH KOREA': 'KOR',
  'SOUTH SUDAN': 'SSD',
  SOUTHAFRICA: 'ZAF',
  SOUTHGEORGIAANDTHESOUTHSANDWICHISLANDS: 'SGS',
  SOUTHKOREA: 'KOR',
  SOUTHSUDAN: 'SSD',
  SPAIN: 'ESP',
  SPM: 'SPM',
  SR: 'SUR',
  SRB: 'SRB',
  'SRI LANKA': 'LKA',
  SRILANKA: 'LKA',
  SS: 'SSD',
  SSD: 'SSD',
  ST: 'STP',
  'STATE OF ISRAEL': 'ISR',
  'STATE OF KUWAIT': 'KWT',
  'STATE OF QATAR': 'QAT',
  STATEOFISRAEL: 'ISR',
  STATEOFKUWAIT: 'KWT',
  STATEOFQATAR: 'QAT',
  STP: 'STP',
  SUDAN: 'SDN',
  'SULTANATE OF OMAN': 'OMN',
  SULTANATEOFOMAN: 'OMN',
  SUR: 'SUR',
  SURINAME: 'SUR',
  SV: 'SLV',
  'SVALBARD AND JAN MAYEN': 'SJM',
  SVALBARDANDJANMAYEN: 'SJM',
  SVK: 'SVK',
  SVN: 'SVN',
  SWE: 'SWE',
  SWEDEN: 'SWE',
  'SWISS CONFEDERATION': 'CHE',
  SWISSCONFEDERATION: 'CHE',
  SWITZERLAND: 'CHE',
  SWZ: 'SWZ',
  SX: 'SXM',
  SXM: 'SXM',
  SY: 'SYR',
  SYC: 'SYC',
  SYR: 'SYR',
  SYRIA: 'SYR',
  'SYRIAN ARAB REPUBLIC': 'SYR',
  SYRIANARABREPUBLIC: 'SYR',
  SZ: 'SWZ',
  TAIWAN: 'TWN',
  'TAIWAN, PROVINCE OF CHINA': 'TWN',
  'TAIWAN,PROVINCEOFCHINA': 'TWN',
  TAJIKISTAN: 'TJK',
  TANZANIA: 'TZA',
  'TANZANIA, UNITED REPUBLIC OF': 'TZA',
  'TANZANIA,UNITEDREPUBLICOF': 'TZA',
  TC: 'TCA',
  TCA: 'TCA',
  TCD: 'TCD',
  TD: 'TCD',
  TF: 'ATF',
  TG: 'TGO',
  TGO: 'TGO',
  TH: 'THA',
  THA: 'THA',
  THAILAND: 'THA',
  'THE STATE OF ERITREA': 'ERI',
  'THE STATE OF PALESTINE': 'PSE',
  THESTATEOFERITREA: 'ERI',
  THESTATEOFPALESTINE: 'PSE',
  'TIMOR-LESTE': 'TLS',
  TJ: 'TJK',
  TJK: 'TJK',
  TK: 'TKL',
  TKL: 'TKL',
  TKM: 'TKM',
  TL: 'TLS',
  TLS: 'TLS',
  TM: 'TKM',
  TN: 'TUN',
  TO: 'TON',
  TOGO: 'TGO',
  'TOGOLESE REPUBLIC': 'TGO',
  TOGOLESEREPUBLIC: 'TGO',
  TOKELAU: 'TKL',
  TON: 'TON',
  TONGA: 'TON',
  TR: 'TUR',
  'TRINIDAD AND TOBAGO': 'TTO',
  TRINIDADANDTOBAGO: 'TTO',
  TT: 'TTO',
  TTO: 'TTO',
  TUN: 'TUN',
  TUNISIA: 'TUN',
  TUR: 'TUR',
  TURKMENISTAN: 'TKM',
  'TURKS AND CAICOS ISLANDS': 'TCA',
  TURKSANDCAICOSISLANDS: 'TCA',
  TUV: 'TUV',
  TUVALU: 'TUV',
  TV: 'TUV',
  TW: 'TWN',
  TWN: 'TWN',
  TZ: 'TZA',
  TZA: 'TZA',
  'TÜRKIYE': 'TUR',
  'U.K.': 'GBR',
  UA: 'UKR',
  UAE: 'ARE',
  UG: 'UGA',
  UGA: 'UGA',
  UGANDA: 'UGA',
  UK: 'GBR',
  UKR: 'UKR',
  UKRAINE: 'UKR',
  UM: 'UMI',
  UMI: 'UMI',
  'UNION OF THE COMOROS': 'COM',
  UNIONOFTHECOMOROS: 'COM',
  'UNITED ARAB EMIRATES': 'ARE',
  'UNITED KINGDOM': 'GBR',
  'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND': 'GBR',
  'UNITED MEXICAN STATES': 'MEX',
  'UNITED REPUBLIC OF TANZANIA': 'TZA',
  'UNITED STATES': 'USA',
  'UNITED STATES MINOR OUTLYING ISLANDS': 'UMI',
  'UNITED STATES OF AMERICA': 'USA',
  UNITEDARABEMIRATES: 'ARE',
  UNITEDKINGDOM: 'GBR',
  UNITEDKINGDOMOFGREATBRITAINANDNORTHERNIRELAND: 'GBR',
  UNITEDMEXICANSTATES: 'MEX',
  UNITEDREPUBLICOFTANZANIA: 'TZA',
  UNITEDSTATES: 'USA',
  UNITEDSTATESMINOROUTLYINGISLANDS: 'UMI',
  UNITEDSTATESOFAMERICA: 'USA',
  URUGUAY: 'URY',
  URY: 'URY',
  US: 'USA',
  USA: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  UZB: 'UZB',
  UZBEKISTAN: 'UZB',
  VA: 'VAT',
  VANUATU: 'VUT',
  VAT: 'VAT',
  VC: 'VCT',
  VCT: 'VCT',
  VE: 'VEN',
  VEN: 'VEN',
  VENEZUELA: 'VEN',
  'VENEZUELA, BOLIVARIAN REPUBLIC OF': 'VEN',
  'VENEZUELA,BOLIVARIANREPUBLICOF': 'VEN',
  VG: 'VGB',
  VGB: 'VGB',
  VI: 'VIR',
  'VIET NAM': 'VNM',
  VIETNAM: 'VNM',
  VIR: 'VIR',
  'VIRGIN ISLANDS OF THE UNITED STATES': 'VIR',
  'VIRGIN ISLANDS, BRITISH': 'VGB',
  'VIRGIN ISLANDS, U.S.': 'VIR',
  'VIRGINISLANDS,BRITISH': 'VGB',
  'VIRGINISLANDS,U.S.': 'VIR',
  VIRGINISLANDSOFTHEUNITEDSTATES: 'VIR',
  VN: 'VNM',
  VNM: 'VNM',
  VU: 'VUT',
  VUT: 'VUT',
  'WALLIS AND FUTUNA': 'WLF',
  WALLISANDFUTUNA: 'WLF',
  'WESTERN SAHARA': 'ESH',
  WESTERNSAHARA: 'ESH',
  WF: 'WLF',
  WLF: 'WLF',
  WS: 'WSM',
  WSM: 'WSM',
  YE: 'YEM',
  YEM: 'YEM',
  YEMEN: 'YEM',
  YT: 'MYT',
  ZA: 'ZAF',
  ZAF: 'ZAF',
  ZAMBIA: 'ZMB',
  ZIMBABWE: 'ZWE',
  ZM: 'ZMB',
  ZMB: 'ZMB',
  ZW: 'ZWE',
  ZWE: 'ZWE',
  'ÅLAND ISLANDS': 'ALA',
  'ÅLANDISLANDS': 'ALA',
}
